import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "rc-pagination/assets/index.css";

import "./assets/global.scss";
// import "./assets/reset.scss";
import "./assets/kits/Colors.scss";
import "./assets/kits/colors/colors.css";
import "./assets/kits/Spacing.scss";
import "./assets/kits/fontSize.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
